import Moment from 'moment';

class CookieControl {  
  getCookie(name) {
    let cName = name + "=";
    let x = 0;
    let i = 0;
    let endOfCookie = null;
    while ( i <= document.cookie.length )
    {
      let y = (x+cName.length);
      if ( document.cookie.substring( x, y ) == cName )
      {
        if ( (endOfCookie=document.cookie.indexOf( ";", y )) == -1 )
          endOfCookie = document.cookie.length;
        return unescape( document.cookie.substring( y, endOfCookie ) );
      }
      x = document.cookie.indexOf( " ", x ) + 1;
      if ( x == 0 ) {
        break;
      }
      i++;
    }
    return "";
  }
  getCookieAll(){
    const cookies = document.cookie.split(";")
    return cookies
  }
  
  setCookie(name, value, expiredays) {
    if(expiredays) {
      const expire = Moment().add(expiredays, 'day').startOf('day').toDate().toGMTString();
      document.cookie = name + '=' + escape(value) + '; path=/; expires=' + expire + ';';
    } else {
      document.cookie = name + '=' + escape(value) + '; path=/;';
    }
  }

}

export default new CookieControl();
